import { mq } from '@stylesheets/tools';
import styled from 'styled-components';

const StyledGuidedTours = styled.div`
  > * {
    padding-bottom: 80px;

    ${mq('m')} {
      padding-bottom: 100px;
    }

    ${mq('l')} {
      padding-bottom: 150px;
    }
  }
`;

export default StyledGuidedTours;
